import React, {ReactNode, useCallback, useState} from 'react';
import {Alert, Button} from 'react-bootstrap';
import styles from './ErrorBoundary.module.scss';

interface ErrorBoundaryProps {
    children: ReactNode;
}

export const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({children}) => {
    const [error, setError] = useState<Error | null>(null);

    const reloadPage = useCallback(() => {
        window.location.reload();
    }, []);

    const ErrorCatcher: React.FC<{ children: ReactNode }> = ({children}) => {
        try {
            if (error) {
                throw error;
            }
            return <>{children}</>;
        } catch (err) {
            // Обновляем состояние ошибки
            setError(err instanceof Error ? err : new Error(String(err)));
            return null;
        }
    };

    if (error) {
        return (
            <div className={styles.container}>
                <Alert variant="danger">
                    <Alert.Heading>Something went wrong</Alert.Heading>
                    <p>
                        Try to refresh page or notify developer about problem
                    </p>
                    {process.env.NODE_ENV === 'development' && error && (
                        <details className={styles.errorDetails}>
                            <summary>Details (dev only)</summary>
                            <pre>{error.stack}</pre>
                        </details>
                    )}
                    <div className={styles.actions}>
                        <Button variant="primary" onClick={reloadPage}>
                            Refresh Page
                        </Button>
                    </div>
                </Alert>
            </div>
        );
    }

    return <ErrorCatcher>{children}</ErrorCatcher>;
};
